import { render, staticRenderFns } from "./selfVipCard.vue?vue&type=template&id=3594e640&scoped=true"
import script from "./selfVipCard.vue?vue&type=script&lang=js"
export * from "./selfVipCard.vue?vue&type=script&lang=js"
import style0 from "./selfVipCard.vue?vue&type=style&index=0&id=3594e640&prod&lang=css"
import style1 from "./selfVipCard.vue?vue&type=style&index=1&id=3594e640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3594e640",
  null
  
)

export default component.exports